import { Icons } from "@/components/ui/Icons";
import { cn } from "@/lib/utils";

export function Spinner({ className }: { readonly className?: string }) {
  return <Icons.Spinner className={cn("animate-spin", className)} />;
}
